import Layout from "layouts";
import { getCouponcode } from "models/couponcodeModel";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CouponDetailComponent from "./CouponDetailComponent";

export default function CouponDetail() {
  const { couponId = "" } = useParams();
  const [couponInfo, setCouponInfo] = useState({});
  const loadData = () => {
    getCouponcode({
      id: couponId,
      onFinish: (res, err) => {
        setCouponInfo(res ?? {});
      },
    });
  };
  useEffect(() => {
    if (Boolean(couponId)) {
      loadData();
    } else {
      setCouponInfo({ type: { label: "Fixed ($)", id: "fixed" } });
    }
    //eslint-disable-next-line
  }, [couponId]);

  return (
    <Layout
      breadCrumb={[
        { label: "Coupons", to: "#" },
        {
          label: !Boolean(couponId)
            ? "Create New Coupon"
            : couponInfo?.code ?? "",
          to: "#",
        },
      ]}
    >
      <CouponDetailComponent couponId={couponId} couponInfo={couponInfo} />
    </Layout>
  );
}
